// Notify user 7 days before his trial ends
export const NOTIFY_FOR_EXPIRE_TRIAL_COUNT_DAY = 7;

export const NOTIFICATIONS_STORAGE_KEY = 'BANNER_NOTIFICATIONS';
